import React from "react";
import { Typography } from "antd";
import { WhatsAppOutlined, SendOutlined } from "@ant-design/icons";
import "../../styles/landing-category.css";
import Reveal from "./Reveal";

const { Title, Paragraph, Text } = Typography;

function ActionButton({
    href,
    icon,
    children,
    variant = "green",
    onClick,
}) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            onClick={onClick}
            className={`landing-btn landing-btn-${variant}`}
        >
            <span>{children}</span>
            <span className="landing-btn-icon">{icon}</span>
        </a>
    );
}

export default function LandingCategory({
    avatar,
    titleTop,
    titleBottom,
    highlightWord,
    members,
    description,
    whatsappLink,
    telegramLink,
    theme = {},
    onWhatsappClick,
}) {
    const sectionStyle = {
        "--bg-primary": theme.bgPrimary || "#07111f",
        "--bg-secondary": theme.bgSecondary || "#050b14",

        // ✅ VERDE NORMAL
        "--highlight": theme.highlight || "#22c55e",

        "--text-color": theme.textColor || "#ffffff",
        "--subtext-color": theme.subTextColor || "rgba(255,255,255,0.88)",
        "--meta-text-color": theme.metaTextColor || "#ffffff",
        "--button-green": theme.buttonGreen || "#22c55e",
        "--button-blue": theme.buttonBlue || "#1692df",
        "--status-dot": theme.statusDot || "#22c55e",
        "--border-color": theme.borderColor || "rgba(255,255,255,0.08)",

        "--glow-color": theme.glowColor || "rgba(34, 197, 94, 0.18)",
    };
    const renderHighlightedText = (text) => {
        if (!highlightWord || !text || !text.includes(highlightWord)) {
            return text;
        }

        const parts = text.split(highlightWord);

        return (
            <>
                {parts[0]}
                <span
                    className="highlight-text"
                    style={{
                        color: "var(--highlight)",
                    }}
                >
                    {highlightWord}
                </span>
                {parts[1]}
            </>
        );
    };

    return (
        <section className="landing-category" style={sectionStyle}>
            <div className="landing-overlay" />

            <div className="landing-content">
                <Reveal delay={0}>
                    <div className="landing-avatar-wrapper">
                        <div className="landing-avatar-glow" />
                        <img src={avatar} alt="Avatar da categoria" className="landing-avatar" />
                        <div className="landing-status-dot" />
                    </div>
                </Reveal>

                <Reveal delay={0.08} y={20}>
                    <Title level={1} className="landing-title">
                        <span>{titleTop}</span>
                        <br />
                        <span>{renderHighlightedText(titleBottom)}</span>
                    </Title>
                </Reveal>

                <Reveal delay={0.16} y={20}>
                    <div className="landing-meta">
                        <Text className="landing-meta-text">100% GRATUITO</Text>
                        <Text className="landing-meta-text">+{members} MEMBROS</Text>
                    </div>
                </Reveal>

                <Reveal delay={0.24} y={22}>
                    <div className="landing-buttons">
                        <ActionButton
                            href={whatsappLink}
                            icon={<WhatsAppOutlined />}
                            variant="green"
                            onClick={onWhatsappClick}
                        >
                            ENTRAR NO GRUPO
                        </ActionButton>

                        {/* <ActionButton
                            href={telegramLink}
                            icon={<SendOutlined />}
                            variant="blue"
                        >
                            ENTRE NO CANAL DO TELEGRAM
                        </ActionButton> */}
                    </div>
                </Reveal>

                <Reveal delay={0.32} y={20}>
                    <Paragraph className="landing-description">
                        {description}
                    </Paragraph>
                </Reveal>
            </div>
        </section>
    );
}